import React from 'react';
import { useQuery } from "react-query";

import * as helpers from '../../utils/utils.js';

import { usePrices } from '../../hooks/usePrices.js';
import { useUnits } from '../../hooks/useUnits.js';
import { useBooking } from '../../hooks/useBooking.js';
import { useSlots } from '../../hooks/useSlots.js';
import { useCustomer } from '../../hooks/useCustomer.js';

function SlotTableRow({ slot, onSelect }) {
    const { getBookingById } = useBooking();
    const { retrieveUnitById } = useUnits();
    const { retrievePriceById } = usePrices();
    const { retrieveCustomerById } = useCustomer();

    const {
        data: booking,
        error: bookingError,
        isLoading: bookingIsLoading,
    } = useQuery(["bookingData", slot?.bookingId], () => getBookingById(slot.bookingId), {
      staleTime: 1000 * 60 * 30,          // 30 minutes
      refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
      cacheTime: 1000 * 60 * 60,          // 1 hour cache
    });
  
    const {
      data: unit,
      error: unitError,
      isLoading: unitIsLoading,
    } = useQuery(["unitData", slot?.unitId], () => retrieveUnitById(slot.unitId), {
      staleTime: 1000 * 60 * 30,          // 30 minutes
      refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
      cacheTime: 1000 * 60 * 60,          // 1 hour cache
    });
  
    const {
      data: price,
      error: priceError,
      isLoading: priceIsLoading,
    } = useQuery(["priceData", slot?.priceId], () => retrievePriceById(slot.priceId), {
      staleTime: 1000 * 60 * 30,          // 30 minutes
      refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
      cacheTime: 1000 * 60 * 60,          // 1 hour cache
    });

    const {
      data: customer,
      error: customerError,
      isLoading: customerIsLoading,
    } = useQuery(["customerData", booking?.customerId], () => retrieveCustomerById(booking.customerId), {
      enabled: !!booking?.customerId,
      staleTime: 1000 * 60 * 30,          // 30 minutes
      refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
      cacheTime: 1000 * 60 * 60,          // 1 hour cache
    });
  
  
    if (bookingIsLoading) return <td colSpan={5}>Loading booking...</td>;
    if (unitIsLoading || priceIsLoading || customerIsLoading) return <td colSpan={5}>Loading...</td>;
    if (bookingError) return <td colSpan={5}>Error: {bookingError.message}</td>;
    if (customerError) return <td colSpan={5}>Error: {customerError.message}</td>;
    if (unitError) return <td colSpan={5}>Error: {unitError.message}</td>;
    if (priceError) return <td colSpan={5}>Error: {priceError.message}</td>;
  
    if (slot && unit && price) return (
      <>
        <td className='unit'>{unit.name}</td>
        <td className="name">{helpers.formatCustomerName(customer)}</td>
        <td className='time'>{helpers.formatTimeRange(price.startTime.hours, price.startTime.minutes, price.duration)}</td>
        <td className='slot'>{booking.slots.findIndex(s => s.id === slot.id)+1}/{booking.slots.length}</td>
        <td className="slot">
          {slot.status}
        </td>

      </>
    );
}

export default SlotTableRow;
